module.exports = __webpack_public_path__ + "increase-visit-white.svg?7322fb9f3e059780e09cbc599b5e5c69";